module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMCAYAAAC0qUeeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAClSURBVHgBzZHBDcMgDEUxygDuBukGCBbISM0ELZO0I3QSwgZpN2AC6HdFpApxaG6xhAD78W1sUtWMMRMR3VVj8I3YbiEETxVkbNxwKcaYJKa1XnPOZ7LWXkspFwk2MEP1AcUZzApmGiQFDidRaUtwzi1QNttdY716oBhSp9/ytNphB4GHfyB8dEYT3qLM6M7Yg+r0ZDjPrzJeeTgXNJ47vAcYt8sHgExCIUYnKmoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-data/new-blank-small.png
// module id = ceF9
// module chunks = 46